/* eslint-disable no-underscore-dangle */
/* eslint-disable class-methods-use-this */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getCountryById } from '../../../../Utils/ElasticUtils';
import {
  changeDestination,
  changeResortOptions,
  changeSearchResult,
  changeSearchInputValue,
  changeSelectedResorts,
  changeCharterOnly,
} from '../../../../DataStore/actions/searchFormActions';
import {
  RESORTS,
  HOTELS,
} from '../../../../Utils/Constants/SearchFormConstants';
import './css/SearchResultPopup.css';
import { TOUR_SEARCH_REGIONS_INDEX } from '../../../../Utils/Constants/Indexes';
import { changeHotelsFilter } from '../../../../DataStore/actions/FiltersAction';
import { ReactComponent as ActiveCheck } from '../../../../images/active-check-r.svg';
import { ReactComponent as DefaultCheck } from '../../../../images/default-check-r.svg';

const mapStateToProps = (state) => ({ ...state });

class SearchResultPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  hadleSelect = (item) => {
    const {
      changeDestination: changeDestinationAction,
      changeSelectedResorts: changeSelectedResortsAction,
      changeHotelsFilter: changeHotelsFilterAction,
      changeSearchResult: changeSearchResultAction,
      changeSearchInputValue: changeSearchInputValueAction,
      destinationButton,
    } = this.props;

    if (item.type === 'country') {
      changeDestinationAction(item);
      changeSelectedResortsAction([]);
      changeHotelsFilterAction([]);
      changeSearchInputValueAction(item.name);
    } else if (item.type === 'region' || item.type === 'subregion') {
      const checkedItem = item;
      checkedItem.checked = true;
      changeSelectedResortsAction([checkedItem]);
      changeHotelsFilterAction([]);

      getCountryById(item.countryId, TOUR_SEARCH_REGIONS_INDEX).then(
        (result) => {
          const country = result.data.hits.hits.map((h) => h._source);
          changeDestinationAction(country[0]);
        },
      );

      destinationButton.click();
    } else if (item.type === 'hotel') {
      getCountryById(item.countryId, TOUR_SEARCH_REGIONS_INDEX).then(
        (result) => {
          const country = result.data.hits.hits.map((h) => h._source);
          changeDestinationAction(country[0]);
        },
      );

      const hotel = item;
      hotel.checked = true;

      changeSelectedResortsAction([]);
      changeHotelsFilterAction([hotel]);
      destinationButton.click();
    }

    changeSearchResultAction([]);
  };

  renderContent = (suggestions) =>
    suggestions.map((item) => (
      <button
        type="button"
        key={item.id}
        className="sf_res_item br_text_18"
        onClick={() => {
          this.hadleSelect(item);
        }}
      >
        <div className="sf_res_item_check_w">
          {item.checked ? (
            <ActiveCheck className="sf_res_item_check_ico" />
          ) : (
            <DefaultCheck className="sf_res_item_check_ico" />
          )}

          <div>{item.name}</div>
        </div>
      </button>
    ));

  getHotelName = (hotel) => {
    if (hotel.stars && hotel.stars > 0) {
      return (
        <span className="sf_dest_serch_hotel_line">
          <span>{`${hotel.name} ${hotel.stars}* `}</span>
          <span className="gr_text_14">{hotel.countryName}</span>
        </span>
      );
    }
    return (
      <span className="sf_dest_serch_hotel_line">
        <span>{`${hotel.name} `}</span>
        <span className="gr_text_14">{hotel.countryName}</span>
      </span>
    );
  };

  renderHotel = (suggestions) =>
    suggestions.map((item) => (
      <button
        type="button"
        key={item.id}
        className="sf_search_hotel_item br_text_16 sf_search_res_item_but"
        onClick={() => {
          this.hadleSelect(item);
        }}
      >
        <div className="sf_search_item_check_w">
          {item.checked ? (
            <div className="sf_search_item_check_ico">
              <ActiveCheck />
            </div>
          ) : (
            <div className="sf_search_item_check_ico">
              <DefaultCheck />
            </div>
          )}

          {item && this.getHotelName(item)}
        </div>
      </button>
    ));

  showResortsLine = (countriesResult, resortsResult) =>
    countriesResult.length > 0 && resortsResult.length > 0;

  showHotelsLine = (countriesResult, resortsResult, hotelsResutl) =>
    (countriesResult.length > 0 || resortsResult.length > 0) &&
    hotelsResutl.length > 0;

  render() {
    const { searchResult } = this.props;
    const { destination, selectedResorts, hotelsFilter } = this.props;

    const search = searchResult.map((e) => {
      let checked;
      if (e.type === 'country') {
        checked = e.id === destination.id;
      } else if (e.type === 'region') {
        checked = selectedResorts.filter((i) => i.id === e.id).length === 1;
      } else if (e.type === 'hotel') {
        checked = hotelsFilter.filter((i) => i.id === e.id).length === 1;
      }

      return { ...e, checked };
    });

    const countriesResult = search.filter((item) => item.type === 'country');
    const resortsResult = search.filter((item) => item.type === 'region');
    const hotelsResult = search.filter((item) => item.type === 'hotel');

    return (
      <div className="sf_search_res_wrapper">
        <div className="sf_search_res_content custom_scroll_container">
          <div className="resort_section">
            {this.renderContent(countriesResult)}
          </div>

          {this.showResortsLine(countriesResult, resortsResult) && (
            <div className="sectionTitleW">
              <div className="sectionSelectedTitleLine" />
              <div className="sectionTitleText">{RESORTS}</div>
              <div className="sectionSelectedTitleLine" />
            </div>
          )}
          <div className="resort_section">
            {this.renderContent(resortsResult)}
          </div>

          {this.showHotelsLine(
            countriesResult,
            resortsResult,
            hotelsResult,
          ) && (
            <div className="sectionTitleW">
              <div className="sectionSelectedTitleLine" />
              <div className="sectionTitleText">{HOTELS}</div>
              <div className="sectionSelectedTitleLine" />
            </div>
          )}
          <div className="resort_section">{this.renderHotel(hotelsResult)}</div>
        </div>
      </div>
    );
  }
}

SearchResultPopup.propTypes = {
  searchResult: PropTypes.instanceOf(Array).isRequired,
  changeDestination: PropTypes.func.isRequired,
  changeSearchResult: PropTypes.func.isRequired,
  changeSearchInputValue: PropTypes.func.isRequired,
  changeSelectedResorts: PropTypes.func.isRequired,
  selectedResorts: PropTypes.instanceOf(Array).isRequired,
  destination: PropTypes.instanceOf(Object).isRequired,
  changeHotelsFilter: PropTypes.func.isRequired,
  destinationButton: PropTypes.instanceOf(Object).isRequired,
  hotelsFilter: PropTypes.instanceOf(Object).isRequired,
};

export default connect(mapStateToProps, {
  changeDestination,
  changeResortOptions,
  changeSearchResult,
  changeSearchInputValue,
  changeSelectedResorts,
  changeCharterOnly,
  changeHotelsFilter,
})(SearchResultPopup);
